import camelCase from 'lodash/camelCase';
import { EventAttributes } from '@atlassiansox/analytics-web-client';
import { AnalyticsEvent } from './analytics-client';
import { analytics } from '..';
import { AnalyticsTag, AnalyticsUiAction, AnalyticsUiSubject } from './constants';

export const createRedirectEvent = (label?: string, attributes?: EventAttributes): AnalyticsEvent => ({
  action: AnalyticsUiAction.CLICKED,
  actionSubject: AnalyticsUiSubject.BUTTON,
  actionSubjectId: camelCase(label) || 'redirectButton',
  attributes: attributes || {},
  tags: [AnalyticsTag.REDIRECT],
});

export const createOpenSidebarFromButtonEvent = (
  sidebar: string,
  label?: string,
  tags?: AnalyticsTag[],
  attributes?: EventAttributes
): AnalyticsEvent => ({
  action: AnalyticsUiAction.CLICKED,
  actionSubject: AnalyticsUiSubject.BUTTON,
  actionSubjectId: camelCase(label) || 'openSideBar',
  attributes: {
    ...attributes,
    sidebar,
  },
  tags: [AnalyticsTag.SIDEBAR, ...(tags || [])],
});

export const createOpenSidebarFromRowEvent = (
  sidebar: string,
  attributes?: EventAttributes,
  tags?: AnalyticsTag[]
): AnalyticsEvent => ({
  action: AnalyticsUiAction.CLICKED,
  actionSubject: AnalyticsUiSubject.TABLE_ROW,
  actionSubjectId: 'openSidebarTableRow',
  attributes: {
    ...attributes,
    sidebar,
  },
  tags: [AnalyticsTag.SIDEBAR, ...(tags || [])],
});

export const createNavItemClickEvent = (
  name: string,
  attributes?: EventAttributes,
  tags?: AnalyticsTag[]
): AnalyticsEvent => ({
  action: AnalyticsUiAction.CLICKED,
  actionSubject: AnalyticsUiSubject.NAV_ITEM,
  actionSubjectId: 'clickableNavItem',
  attributes: {
    ...attributes,
    name,
  },
  tags: [AnalyticsTag.NAVBAR, ...(tags || [])],
});

export const createFilterChangeEvent = (
  actionSubjectId: string,
  attributes?: EventAttributes,
  tags?: AnalyticsTag[]
): AnalyticsEvent => ({
  action: AnalyticsUiAction.CHANGED,
  actionSubject: AnalyticsUiSubject.FILTER,
  actionSubjectId: actionSubjectId,
  attributes: attributes || {},
  tags: tags || [],
});

const createSearchFormEvent = (attributes?: EventAttributes, tags?: AnalyticsTag[]): AnalyticsEvent => ({
  action: AnalyticsUiAction.SEARCHED,
  actionSubject: AnalyticsUiSubject.FORM,
  actionSubjectId: 'searchForm',
  attributes: attributes || {},
  tags: tags || [],
});

export const trackSearchFormEvent = (attributes?: EventAttributes, tags?: AnalyticsTag[]) => {
  analytics.sendUIEvent(createSearchFormEvent(attributes, tags));
};

export const createButtonClickEvent = (
  label: string,
  tags?: AnalyticsTag[],
  attributes?: EventAttributes
): AnalyticsEvent => ({
  action: AnalyticsUiAction.CLICKED,
  actionSubject: AnalyticsUiSubject.BUTTON,
  actionSubjectId: label,
  attributes: attributes || {},
  tags: tags || [],
});

const createSearchEvent = (attributes?: EventAttributes, actionSubjectID?: string): AnalyticsEvent => ({
  action: AnalyticsUiAction.SEARCHED,
  actionSubject: 'user',
  actionSubjectId: actionSubjectID || '',
  attributes: attributes || {},
});

export const trackSearchEvent = (attributes?: EventAttributes, actionSubjectID?: string) => {
  analytics.sendUIEvent(createSearchEvent(attributes, actionSubjectID));
};

export const trackButtonClick = (actionSubjectId: string, attributes?: EventAttributes) => {
  analytics.sendUIEvent({
    action: AnalyticsUiAction.CLICKED,
    actionSubject: AnalyticsUiSubject.BUTTON,
    actionSubjectId: actionSubjectId,
    attributes: attributes,
  });
};

export const trackLinkClick = (actionSubjectId: string, attributes?: EventAttributes) => {
  analytics.sendUIEvent({
    action: AnalyticsUiAction.CLICKED,
    actionSubject: AnalyticsUiSubject.LINK,
    actionSubjectId: actionSubjectId,
    attributes: attributes,
  });
};

export const sendAnalyticsEvent = (action: string, actionSubject: string, attributes?: EventAttributes) => {
  analytics.sendTrackEvent({
    action: action,
    actionSubject: actionSubject,
    attributes: attributes || {},
  });
};

export const sendSideBarButtonClickEvent = (attributes?: EventAttributes) => {
  analytics.sendUIEvent({
    action: AnalyticsUiAction.CLICKED,
    actionSubject: AnalyticsUiSubject.SIDEBAR_BUTTON,
    attributes: attributes || {},
  });
};
